import gql from "graphql-tag";

export const SUBSCRIBE_MY_BATCHES = gql`
    subscription BatchTable($orgId: uuid!){
        BatchTable(where: {_and: [{ownedBy: {_eq: $orgId}},{status: {_eq: "InStock"}}]},order_by: {createdOn: desc}){
            id
            productId
            sku
            batch
            Product{name productLineCode}
        }
    }
`
export const SUBSCRIBE_MY_BATCHES_GROUP_BY_PRODUCT = gql`
    subscription Product($orgId: uuid!,  $filter:String!){
        Product(order_by: {name: asc}){
            id
            name
            RDPrice
            RPPrice
            NDPrice
            VADPrice
            VAPPrice
            VPPrice
            batches_aggregate(where: {ownedBy: {_eq: $orgId}, status: {_eq: "InStock"},  batch: {_ilike: $filter}}) {
                aggregate {
                    count
                }
            }
        }
    }`

export const SUBSCRIBE_ACTIVE_NOT_SOLD_SUB_BATCH = gql`
subscription getActiveSubBachNotSold($orgId: uuid!){
    subBatches: ProductInventory(where: {_and: [{ownedBy: {_eq: $orgId}},{status: {_eq: "InStock"}}, {isActivated: {_eq: true}}]}){
        id
        serial       
    }
}`

export const SUBSCRIBE_ACTIVE_SUB_BATCH_DETAILS = gql`
subscription getActiveSubBachDetails($orgId: uuid!){
  batches: BatchTable(where: {ProductInventories: {ownedBy: {_eq: $orgId}, isActivated: {_eq: true}, status: {_eq: "InStock"}}}){
     id
     batch
     Product { id name }
     subBatches: ProductInventories(where: {ownedBy: {_eq: $orgId}, isActivated: {_eq: true}, status: {_eq: "InStock"}}) {
       id
       serial  
     }                
  }
}`